module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/main-bg-sp_4c05ca98029e3ff4d400cb2c0b7ce550.png";